import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CUSTOM_FEATURE_KEY, CustomState, customAdapter } from './custom.reducer';

// Lookup the 'Custom' feature state managed by NgRx
export const selectCustomState = createFeatureSelector<CustomState>(CUSTOM_FEATURE_KEY);

const { selectAll, selectEntities } = customAdapter.getSelectors();

export const getCustomInfoState = createFeatureSelector<CustomState>(CUSTOM_FEATURE_KEY);

export const GetCustomConversionList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customConversionList
);

export const GetCustomTruckList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customTruckList
);

export const GetCustomReuseList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customReuseList
);

export const GetCustomStorageList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customStorageList
);

export const GetCustomFillingList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customFillingList
);

export const GetCustomTransportList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customTransportList
);

export const GetCustomWasteList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customWasteList
);

export const GetMaterialIngredientList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.materialIngredientList
);

export const GetcopiedMaterialIngredient = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.copiedMaterialIngredient
);

export const isIngredirentEdit = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.isIngredirentEdit
);

export const GetMaterialProcessList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.materialProcessList
);

export const GetConversionProcessList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.conversionProcessList
);

export const GetConversionData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.conversionData
);

export const GetCustomTruckData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customTruckdata
);

export const GetCustomFillingData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customFillingdata
);

export const GetCustomMaterialError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customMaterialError
);

export const GetCustomMaterialProcessError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customMaterialProcessError
);

export const GetCustomConversionProcessError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customConversionProcessError
);

export const GetCustomFillingProcessError = createSelector(
  getCustomInfoState,

  (state: CustomState) => state.customFillingProcessError
);

export const GetDeleteCustomData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.getDeleteCustomData
);

export const checkUpdateActionFireSelector = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.checkUpdateActionFire
);
export const distanceErrorProjectCustom = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.distanceErrorProjectCustom
);

export const GetCopiedCustomMaterial = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.getCopiedCustomMaterial
);

export const DisplayErrorMessage = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.error
);

export const GetCustomTruckError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customTruckError
);

export const GetTruckTypeList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.truckTypeList
);

export const GetFillingIngredientList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.fillingIngredientList
);

export const GetcopiedFillingIngredient = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.copiedFillingIngredient
);

export const isIngredirentEditFilling = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.isIngredirentEditFilling
);

export const GetStorageProcessList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.storageProcessList
);

export const GetStorageData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.storageData
);

export const GetcopiedStorageProcess = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.copiedStorageProcess
);

export const isProcessEditStorage = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.isProcessEditStorage
);

export const GetCustomStorageError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customStorageError
);

export const GetCustomMaterialIngredirentError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customMaterialIngredirentError
);

export const GetWasteScenarioProcessList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.wasteScenarioProcessList
);

export const GetWasteScenarioData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.wasteScenarioData
);

export const GetcopiedWasteScenarioProcess = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.copiedWasteScenarioProcess
);

export const isProcessEditWasteScenario = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.isProcessEditWasteScenario
);

export const GetCustomWasteScenarioError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customWasteScenarioError
);

export const GetWasteGridData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.wasteGridData
);

export const GetReuseIngredientList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.reuseIngredientList
);
export const GetReuseData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.reuseData
);

export const GetCustomReuseError = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customReuseError
);

export const isIngredirentEditReuse = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.isIngredirentEditReuse
);

export const GetcopiedReuseIngredient = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.copiedReuseIngredient
);

//For Add-Edit Transport Scenario
export const GetTransportScenarioList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.transportScenarioList
);

export const GetTransportListRowData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.transportListRowData
);

export const GetReplicaTransportScenarioList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.replicateTransportScenarioList
);

export const GetMultipleTransportScenarioList = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.multipleTransportScenarioList
);

export const GetDeleteCovertingProcess = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.getDeleteCovertingProcess
);

export const GetMultipleTransportErrorMessage = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customMultipleTransportScenarioError
);

export const GetTransportErrorMessage = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customTransportScenarioError
);

export const GetRemainingValue = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.remainingValue
);

export const GetCustomMaterialData = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.newCustomMaterialData
);

export const GetMaterialItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.materialItems
);
export const GetEndofLifeIdentifierItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.endofLifeIdentifierItems
);

export const GetEnergyItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.energyItems
);

export const GetUnitItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.unitItems
);

export const GetTruckListItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.truckList
);

export const GetrefrigerationItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.refrigerationList
);

export const GetCustomFillingEnergyItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customFillingenergyItems
);

export const GetUnitofProductItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.unitofProductItems
);
export const GetorganizationItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.organizationItems
);

export const GetcustomStorageEnergyItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customStorageEnergyItems
);

export const GetcustomReuseEnergyItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customReuseEnergyItems
);
export const GetcustomWestWasteMaterialItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customWestWasteMaterialItems
);
export const GetcustomWestlocationItems = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customWestlocationItems
);
export const GetcustomWestOrganizationlist = createSelector(
  getCustomInfoState,
  (state: CustomState) => state.customWestOrganizationlist
);
